export const DEFAULT_PENCIL_COLOR = '#38bdf8';

const HEX_COLOR_PATTERN = /^#[0-9a-f]{6}$/i;

export const isHexColor = (value: string): boolean => HEX_COLOR_PATTERN.test(value.trim());

export const normalizeHexColor = (value: string, fallback = DEFAULT_PENCIL_COLOR): string => {
  const normalized = value.trim().toLowerCase();
  return isHexColor(normalized) ? normalized : fallback;
};

export const hexToRgba = (value: string, alpha: number): string => {
  const normalized = normalizeHexColor(value);
  const red = Number.parseInt(normalized.slice(1, 3), 16);
  const green = Number.parseInt(normalized.slice(3, 5), 16);
  const blue = Number.parseInt(normalized.slice(5, 7), 16);
  return `rgba(${red},${green},${blue},${alpha})`;
};
